import http from "../http-common"

class MasterDataService {


    updateEmail(data, id, token) {
        return http.put(`api/emails/${id}`, data, {
            headers: {
                Authorization: token
            }
        });
    }

    getOneCampaign(id, token) {
        return http.get(`api/campaigns/${id}`, {
            headers: {
                Authorization: token
            }
        })
    }
    getOneEmail(id, token) {
        return http.get(`api/emails/${id}`, {
            headers: {
                Authorization: token
            }

        })
    }
    getOneProfileOwner(id, token) {
        return http.get(`api/profile_owners/${id}`, {
            headers: {
                Authorization: token
            }
        })
    }


}

export default new MasterDataService();